import React from "react";
import {useTranslation} from "react-i18next";
import "../banner.css";

const InfoBanner = () => {
  const {t} = useTranslation();
  return (
    <div className="banner" id="info-banner">
      <div className="container">
        <div className="banner-text">
          <h2>{t("banner.info.title")}</h2>
          <p>{t("banner.info.text")}</p>
        </div>
      </div>
    </div>
  )
};

export default InfoBanner;
